import { Eye } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  authorName?: string | null
  authorAvatar?: string | null
  viewsCount?: number
  /** 'lg' = 6×6 avatar / text-sm / px-3.5 py-2 (cover previews); 'sm' = 5×5 / text-xs / px-3 py-1.5 (list card) */
  size?: 'lg' | 'sm'
  className?: string
}

export const CoverBadge = ({
  authorName,
  authorAvatar,
  viewsCount = 0,
  size = 'lg',
  className,
}: Props) => {
  const m = useMessages(messages)
  const isLarge = size === 'lg'
  const avatarSize = isLarge ? 'w-6 h-6' : 'w-5 h-5'
  const eyeSize = isLarge ? 'w-3.5 h-3.5' : 'w-3 h-3'
  const textSize = isLarge ? 'text-sm' : 'text-xs'
  const nameMax = isLarge ? 'max-w-[90px]' : 'max-w-[70px]'
  const padding = isLarge ? 'px-3.5 py-2' : 'px-3 py-1.5'

  // white by design: badge sits over the cover image/gradient, not app surface
  return (
    <div
      className={cn(
        'flex items-center justify-center gap-2 bg-white/20 backdrop-blur-sm rounded-full mx-auto w-fit',
        padding,
        className,
      )}
    >
      {authorAvatar ? (
        <img src={authorAvatar} alt="" className={cn(avatarSize, 'rounded-full object-cover')} />
      ) : (
        <div className={cn(avatarSize, 'rounded-full bg-white/30')} />
      )}
      <span className={cn('text-white font-medium truncate', textSize, nameMax)}>
        {authorName ?? m.author}
      </span>
      <Eye className={cn(eyeSize, 'text-white/70')} />
      <span className={cn('text-white/70', textSize)}>{viewsCount}</span>
    </div>
  )
}
